import { styled } from '@linaria/react';
import { breakpoints, space } from '../../theme/tokens';

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space[5]};
  margin-bottom: ${space[10]};

  @media (min-width: ${breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${breakpoints.desktop}) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: ${breakpoints.wide}) {
    grid-template-columns: repeat(4, 1fr);
  }
`;
